<main class="vjMain">
  <header class="vjMainHeader">
    <div class="vjBranding" [ngStyle]="{'background-image': 'url(' + headerImage + ')'}"></div>
  </header>
  <section class="vjMainContainer" [ngClass]="{ 'sideMenuCollapse' : menuPanelCollapsed }">
    <aside class="vjSidebar">
      <!-- vj hdr wrap -->
      <h2 class="vjHeaderWrap">
        <span>Menu</span>
        <i class="vjCollapse icon-double-arrow-left" (click)="menuPanelCollapsed = !menuPanelCollapsed"></i>
      </h2>
      <ul class="vjMainMenu">
        <li *ngFor="let menuItem of menus"
          [ngClass]="{ 'vjMainMenu_parentMenu' : (menuItem.children && menuItem.children.length > 0), 'childActive': displayChildMenu }">
          <a (click)="onMenuClick(menuItem)" id="{{ menuItem.name }}" [ngClass]="{ 'active': menuItem.active }"
            [title]="menuItem.name">
            <div class="vjMenuImage">
              <span class="vjMenuIcon" [ngStyle]="{
                  'mask-image': 'url(' + menuItem?.iconClassName + ')',
                  '-webkit-mask-image': 'url(' + menuItem?.iconClassName + ')',
                  'background-color': menuItem.active ? selectedSectionColor : unselectedSectionColor
                }">
              </span>
            </div>
            <span [ngStyle]="{'color': menuItem.active ? selectedSectionColor : unselectedSectionColor}">{{
              menuItem.name }}</span>
          </a>
          <ng-container *ngIf="menuItem.children && menuItem.children.length > 0">
            <i class="icon-chevron-up"></i>
            <ul>
              <li *ngFor="let menuChildItem of menuItem.children">
                <a (click)="onMenuClick(menuChildItem)" id="{{ menuChildItem.name }}" [title]="menuChildItem.name">
                  <span
                    [ngStyle]="{'color': menuChildItem.name === translocoService.gettransloco('MENU.LOGOUT') ? '#ec6b6b' : 
                    (menuChildItem.active ? selectedSectionColor : unselectedSectionColor)}">{{
                    menuChildItem.name }}</span>
                </a>
              </li>
            </ul>
          </ng-container>
        </li>
        <ng-container *ngIf="moreMenus?.length > 0">
          <li (click)="openMobileViewMenus()" class="vjMoreMenu">
            <a>
              <div class="vjMenuImage">
                <i class="icon-three-dots"></i>
              </div>
            </a>
          </li>
        </ng-container>
      </ul>
      <ul class="vjSidebar_card">
        <!-- <li>
          <h2 class="subTitle">{{ 'MODULES.COMMON.CONTACT_US' | transloco }}</h2>
          <p>{{ contactusInformation.text }}</p>
          <span>{{ 'MODULES.COMMON.MAIL' | transloco }}{{ contactusInformation.mail }}</span>
          <span>{{ 'MODULES.COMMON.US' | transloco }}{{ contactusInformation.us }}</span>
        </li> -->
        <li *ngIf="privacyPolicyUrl || termsUrl || accessibilityUrl || helpUrl">
          <a *ngIf="privacyPolicyUrl" (click)="openPrivacyPolicy()" style="cursor: pointer;">{{
            'MODULES.PLAYER_INFORMATION.PRIVACY_POLICY' | transloco }}</a><br *ngIf="privacyPolicyUrl">
          <a *ngIf="termsUrl" (click)="openTermsAndConditions()" style="cursor: pointer;">{{
            'MODULES.PLAYER_INFORMATION.TERMS_AND_CONDITIONS' | transloco }}</a><br *ngIf="termsUrl">
          <a *ngIf="accessibilityUrl" (click)="openAccessibility()" style="cursor: pointer;">{{
            'MODULES.PLAYER_INFORMATION.ACCESSIBILITY' | transloco }}</a><br *ngIf="accessibilityUrl">
          <a *ngIf="helpUrl" (click)="openHelp()" style="cursor: pointer;">{{
            'MODULES.PLAYER_INFORMATION.HELP' | transloco }}</a>
        </li>
        <li>
          <p>{{ 'MODULES.COMMON.DOWNLOAD_APP_MESSAGE' | transloco }}</p>
          <a href="{{downloadAppInformation.iOS}}"><img src="../../../resources/images/app-store.svg" /></a>
          <a href="{{downloadAppInformation.Android}}"><img src="../../../resources/images/google-play.svg" /></a>
        </li>
      </ul>
    </aside>
    <section class="vjBody">
      <router-outlet></router-outlet>
    </section>
  </section>
  <footer class="vjMainFooter">
    <p>{{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}</p>
  </footer>
  <i class="dsIcon icon-chevron-up vjScrollUp" (click)="scrollToTop()"></i>
</main>